import { HttpClient } from '@src/clients/HttpClient.js';
import { ConsentUpdate, ConsentUpdateList, Purpose } from '@src/types/model.js';

export interface Api4pClientOptions {
  apiUrl: string;
  altFetch?: string;
  accessToken?: string;
  traceid?: string;
}

export class Api4pClient {
  httpClient: HttpClient;

  public constructor({
    apiUrl, altFetch, accessToken, traceid,
  } : Api4pClientOptions) {
    this.httpClient = new HttpClient({
      apiUrl,
      accessToken,
      altFetch,
      traceid,
    });
  }

  public async getConsents(spId?: string, lcId?: string): Promise<Purpose[]> {
    const path = '/services/mfe/consents';

    let query = {};
    if (spId && lcId) {
      query = { lcId, spId };
    }

    return this.httpClient.get<Purpose[]>(path, query);
  }

  public async postConsentsUpdateList(tenant: string, consents: ConsentUpdate[], spId?: string, lcId?: string) {
    const path = '/services/mfe/consents';
    const headers = {
      'x-tenant': tenant,
    };

    let query = {};
    if (spId && lcId) {
      query = { lcId, spId };
    }

    return this.httpClient.post<ConsentUpdateList>(path, { consents }, query, headers);
  }
}
